import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = {
  key: 0,
  class: "kakugo w100",
  style: {"height":"120px","top":"0","z-index":"10"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "ofh w80 fl",
  style: {"margin-top":"25px"}
}, [
  /*#__PURE__*/_createElementVNode("h4", {
    class: "fs20 ls1 fl",
    style: {"margin-left":"80px","margin-top":"24px"}
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "アカウント")
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "w100",
  style: {"height":"50px","text-align":"middle","border-bottom":"1px solid #ddd"}
}
const _hoisted_8 = {
  key: 1,
  class: "posAb",
  style: {"top":"20px","right":"60px","width":"280px"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "fs11 mt5" }, " waaqのサポートを許可します。許可すると、ご利用状況を確認しながら、適宜サポートさせていただきます。 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AdLimitFree = _resolveComponent("AdLimitFree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isSP)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.rm.userInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (!_ctx.isSP)
            ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
                (_ctx.UserPermissionsOption.permitDisplay(_ctx.rm.userInfo, `account_settings`, `account_settings_organization`))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/account_settings"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(`roomsCategoryTab pointer centered fl ${_ctx.selectedTab == 'group' ? 'selected fw600' : ''}`),
                          style: {"width":"140px"}
                        }, " 企業設定 ", 2)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.UserPermissionsOption.permitDisplay(_ctx.rm.userInfo, `account_settings`, `account_settings_notifications`))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: "/account_settings/notifications"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(`roomsCategoryTab pointer centered fl ${_ctx.selectedTab == 'notifications' ? 'selected fw600' : ''}`),
                          style: {"width":"140px"}
                        }, " 外部通知設定 ", 2)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.UserPermissionsOption.permitDisplay(_ctx.rm.userInfo, `account_settings`, `account_settings_security`))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 2,
                      to: "/account_settings/security"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(`roomsCategoryTab pointer centered fl ${_ctx.selectedTab == 'security' ? 'selected fw600' : ''}`),
                          style: {"width":"140px"}
                        }, " セキュリティ ", 2)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_router_link, { to: "/account_settings/saml" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(`roomsCategoryTab pointer centered fl ${_ctx.selectedTab == 'saml' ? 'selected fw600' : ''}`),
                      style: {"width":"140px"}
                    }, " SSO ", 2)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", {
                  class: _normalizeClass(`roomsCategoryTab pointer centered fl ${_ctx.selectedTab == 'payment' ? 'selected fw600' : ''}`),
                  style: {"width":"140px"},
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickPayment && _ctx.clickPayment(...args)))
                }, " お支払い ", 2)
              ]))
            : _createCommentVNode("", true),
          (_ctx.rm)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: _normalizeClass(`posRe circle_button fs13 rad4 ${_ctx.rm.support_waaq ? `skyblueBg fw600` : ``}`),
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickWaaqSupport && _ctx.clickWaaqSupport(...args)))
                }, " waaqサポートに管理者権限を許可" + _toDisplayString(_ctx.rm.support_waaq ? `済` : ``), 3),
                _hoisted_9
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_AdLimitFree, {
      showAds: _ctx.showAds,
      addFrom: _ctx.from,
      onFadeOutAdModal: _ctx.fadeOutAdModal
    }, null, 8, ["showAds", "addFrom", "onFadeOutAdModal"])
  ]))
}